/* ==========================================================================
   Snipes — Tabbed Product Carousel
   Tabs, arrow scrolling, drag-to-scroll, lazy looping video.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.snpReady === 'true') return;
    root.dataset.snpReady = 'true';

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-snp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-snp-panel]'));
    var prevBtn = root.querySelector('[data-snp-prev]');
    var nextBtn = root.querySelector('[data-snp-next]');

    function activeTrack() {
      var panel = root.querySelector('.snp-tp__panel.is-active');
      return panel ? panel.querySelector('[data-snp-track]') : null;
    }

    function stepSize(track) {
      var item = track.querySelector('.snp-tp__item');
      if (!item) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var track = activeTrack();
      if (!track || !prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= max;
    }

    /* ----- Tabs ----- */
    function selectTab(index) {
      pills.forEach(function (pill) {
        var on = pill.dataset.snpTab === String(index);
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var on = panel.dataset.snpPanel === String(index);
        panel.classList.toggle('is-active', on);
        if (on) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
          pauseVideosIn(panel);
        }
      });

      var track = activeTrack();
      if (track) {
        track.scrollLeft = 0;
        playVisibleVideos();
      }
      updateArrows();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selectTab(pill.dataset.snpTab);
      });
    });

    /* ----- Arrows ----- */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var track = activeTrack();
        if (track) track.scrollBy({ left: -stepSize(track), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var track = activeTrack();
        if (track) track.scrollBy({ left: stepSize(track), behavior: 'smooth' });
      });
    }

    /* ----- Drag to scroll -----
       Mouse only. Touch devices use native scrolling, so a tap always
       reaches the product link. The is-dragging class (which disables
       pointer events on links) is added only once the pointer has really
       moved — adding it on pointerdown swallows ordinary clicks. */
    root.querySelectorAll('[data-snp-track]').forEach(function (track) {
      var down = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        down = true;
        moved = 0;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (event) {
        if (!down) return;
        var delta = event.clientX - startX;
        moved = Math.abs(delta);

        if (moved > 4) {
          if (!track.classList.contains('is-dragging')) {
            track.classList.add('is-dragging');
          }
          if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
          track.scrollLeft = startScroll - delta;
        }
      });

      function endDrag(event) {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (event && event.pointerId != null && track.hasPointerCapture && track.hasPointerCapture(event.pointerId)) {
          track.releasePointerCapture(event.pointerId);
        }
        updateArrows();
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Only swallow the click that ends a real drag
      track.addEventListener('click', function (event) {
        if (moved > 6) {
          event.preventDefault();
          event.stopPropagation();
          moved = 0;
        }
      }, true);

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });
    });

    /* ----- Video: load and loop only while on screen ----- */
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-snp-video]'));

    function pauseVideosIn(scope) {
      scope.querySelectorAll('[data-snp-video]').forEach(function (video) {
        if (!video.paused) video.pause();
      });
    }

    function playVideo(video) {
      if (video.dataset.snpLoaded !== 'true') {
        video.dataset.snpLoaded = 'true';
        video.load();
      }
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    }

    var observer = null;
    if ('IntersectionObserver' in window && videos.length) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          var hidden = video.closest('.snp-tp__panel');
          if (entry.isIntersecting && (!hidden || hidden.classList.contains('is-active'))) {
            playVideo(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.1 });

      videos.forEach(function (video) { observer.observe(video); });
    } else {
      videos.forEach(playVideo);
    }

    function playVisibleVideos() {
      if (!observer) return;
      videos.forEach(function (video) {
        observer.unobserve(video);
        observer.observe(video);
      });
    }

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(updateArrows);
    });

    updateArrows();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-snp-tabs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', function (event) {
    initAll(event.target);
  });
})();
